import common from './common.json';
import auth from './auth.json';
import validation from './validation.json';
import home from './home.json';
import travels from './travels.json';
import payment from './payment.json';
import profile from './profile.json';
import pages from './pages.json';
import admin from './admin.json';

const fr = { common, auth, validation, home, travels, payment, profile, pages, admin };
export default fr;
